import { APIResource } from 'services'
import { CamelizeResponseDecorator } from 'utils'
import { ProtectResourceDecorator } from 'services/TokenStore'

export type API = {
  [action: string]: (...args: any[]) => unknown;
}

export const ProtectedJsonAPI = new APIResource('',{},{ decorators: [ProtectResourceDecorator, CamelizeResponseDecorator]}) as any as API